import React, { useEffect } from 'react';
import './Philosophy.css';
import usePageTitle from '../hooks/usePageTitle';
import { useLanguage } from '../hooks/useLanguage';
import borderImage from '../assets/border.png';
import philosophyBg from '../assets/philosophy.png';

const Philosophy: React.FC = () => {
  const { t } = useLanguage();
  usePageTitle(t('philosophy.title'));
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Remove animation classes first to reset
    const allElements = document.querySelectorAll('.philosophy-title, .philosophy-subtitle, .philosophy-description, .philosophy-paragraph');
    allElements.forEach(element => {
      element.classList.remove('animate-in-initial');
    });
    
    // Force reflow to ensure the removal is processed
    void document.body.offsetHeight;
    
    // Animate initial content on page load
    // Title animates first
    const titleElement = document.querySelector('.philosophy-title');
    if (titleElement) {
      setTimeout(() => {
        titleElement.classList.add('animate-in-initial');
      }, 200);
    }
    
    // Subtitle animates after title
    const subtitleElements = document.querySelectorAll('.philosophy-subtitle');
    setTimeout(() => {
      subtitleElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 210);
    
    // Paragraphs animate 200ms after subtitle
    const paragraphElements = document.querySelectorAll('.philosophy-description, .philosophy-paragraph');
    setTimeout(() => {
      paragraphElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 410);
  }, []);

  return (
    <div className="philosophy-page">
      <img src={philosophyBg} alt="" className="philosophy-background" />
      <div className="philosophy-container">
        <h1 className="philosophy-title">{t('philosophy.title')}</h1>

        <div className="philosophy-content">
          <h2 className="philosophy-subtitle">
            <em><strong>Sapientia per Laborem.</strong></em> {t('philosophy.subtitle').split('.').slice(1).join('.').trim()}
          </h2>

          <img src={borderImage} alt="" className="philosophy-border-image" />

          <p className="philosophy-description">
            <strong>{t('philosophy.intro')}</strong>
          </p>

          <div className="philosophy-text">
            <p className="philosophy-paragraph">{t('philosophy.para1')}</p>
            <p className="philosophy-paragraph">{t('philosophy.para2')}</p>
            <p className="philosophy-paragraph">{t('philosophy.para3')}</p>
            <p className="philosophy-paragraph">{t('philosophy.para4')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Philosophy;